var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',_vm._g(_vm._b({attrs:{"type":"selection","width":"46","align":"center"}},'el-table-column',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }